// icon:bx-network-chart | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Galaxy.png";

function IconBxNetworkChart(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Galaxy"} />
	)
}

export default IconBxNetworkChart;
